import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-interests',
  storeModule.createStoreModule('real-estate-developments-interests')
)
